import { Navigate } from 'react-router-dom';
import useAuthStore from '@store/useAuthStore';

export default function PublicRoute({ children }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  if (isAuthenticated) {
    return <Navigate to="/projects" replace />;
  }

  return children;
}
